import {
  createRootRoute,
  createRoute,
  createRouter,
  redirect,
  type RouterHistory,
} from '@tanstack/react-router'
import { Button, EmptyState } from './design'
import { CorpusPage } from './features/corpus/CorpusPage'
import { ItemPage } from './features/item/ItemPage'
import { KnowledgePage } from './features/knowledge/KnowledgePage'
import { OperationsPage } from './features/operations/OperationsPage'
import { QueuePage } from './features/queue/QueuePage'
import { SettingsPage } from './features/settings/SettingsPage'
import { UsagePage } from './features/usage/UsagePage'
import { AppShell } from './shell/AppShell'
import { SHELL_COPY } from './shell/copy'
import { QueueWorkspace } from './shell/QueueWorkspace'
import { QueueSearch } from './shell/queueSearch'

const NotFound = () => (
  <EmptyState
    title={SHELL_COPY.notFoundTitle}
    description={SHELL_COPY.notFoundBody}
    action={
      <Button variant="primary" onClick={() => window.location.assign('/')}>
        {SHELL_COPY.backToQueue}
      </Button>
    }
  />
)

const rootRoute = createRootRoute({
  component: () => (
    <AppShell>
      <QueueWorkspace />
    </AppShell>
  ),
  notFoundComponent: NotFound,
})

const queueRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/',
  validateSearch: QueueSearch,
  component: QueuePage,
})

const itemRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/items/$itemId',
  validateSearch: QueueSearch,
  component: ItemPage,
})
const corpusRoute = createRoute({ getParentRoute: () => rootRoute, path: '/corpus', component: CorpusPage })
const knowledgeRoute = createRoute({ getParentRoute: () => rootRoute, path: '/knowledge-base', component: KnowledgePage })
const legacyKnowledgeRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/kb',
  beforeLoad: () => {
    throw redirect({ to: '/knowledge-base', replace: true })
  },
})
const settingsRoute = createRoute({ getParentRoute: () => rootRoute, path: '/settings', component: SettingsPage })
const usageRoute = createRoute({ getParentRoute: () => rootRoute, path: '/usage', component: UsagePage })
const operationsRoute = createRoute({ getParentRoute: () => rootRoute, path: '/ops', component: OperationsPage })

const routeTree = rootRoute.addChildren([
  queueRoute,
  itemRoute,
  corpusRoute,
  knowledgeRoute,
  legacyKnowledgeRoute,
  usageRoute,
  settingsRoute,
  operationsRoute,
])

export const createAppRouter = (options: { history?: RouterHistory } = {}) =>
  createRouter({ routeTree, defaultPreload: false, ...options })

declare module '@tanstack/react-router' {
  interface Register {
    router: ReturnType<typeof createAppRouter>
  }
}
